/* ============================================================================
 * PRODUCT CORE FUNCTIONALITY (js__product-core.js)
 * ============================================================================ */

// --- Constants ---
const getProductBtns = (form) => form.querySelectorAll('.quantity-wrapper button[type="button"]');
const disableBtns = (form) => getProductBtns(form).forEach(btn => btn.disabled = true);
const enableBtns = (form) => getProductBtns(form).forEach(btn => btn.disabled = false);

// --- Core Variant Change Function ---
window.onChangeProductOption = (input) => {
  const form = input.closest('form');
  const quantityInput = form.querySelector('input[name="quantity"]');
  const quantityDisplay = form.querySelector('.cart-quantity');
  const btnPlus = form.querySelector('.btn-plus');
  const btnMinus = form.querySelector('.btn-minus');
  const btnTxt = form.querySelector('.btn-cart span:first-child');
  const idInput = form.querySelector('[name="id"]');
  const selectedOptions = [];

  form.querySelectorAll('.product-option').forEach(elem => {
    if (elem.type === 'radio') {
      if (elem.checked) {
        selectedOptions.push(elem.value);
      }
    } else {
      selectedOptions.push(elem.value);
    }
  });

  const selectedVariant = window.productVariants.find(
    variant => JSON.stringify(variant.options) === JSON.stringify(selectedOptions)
  );

  window.currentVariant = selectedVariant;

  if (!selectedVariant) {
    disableBtns(form);
    btnTxt.innerHTML = `${window.theme.product.unavailable}`;
    return;
  }

  idInput.value = selectedVariant.id;
  const url = new URL(window.location);
  url.searchParams.set('variant', selectedVariant.id);
  window.history.replaceState({}, '', url);
  
  if (selectedVariant.available) {
    enableBtns(form);
    btnTxt.innerHTML = `${window.theme.product.addToCart}`;

    // 1. Reset quantity to 1
    quantityInput.value = 1;
    quantityDisplay.textContent = 1;

    // 2. Determine maxQuantity
    const hasInventory = selectedVariant.inventory_management === 'shopify';
    const isContinuing = selectedVariant.inventory_policy === 'continue';

    let maxQuantity = 9999;
    if (hasInventory && !isContinuing) {
        maxQuantity = selectedVariant.inventory_quantity;
    }
    
    // 3. Set the max on the button
    btnPlus.dataset.max = maxQuantity;

    // 4. Manually update button states
    btnMinus.disabled = true;
    let cleanMax = parseInt(maxQuantity);
    if (isNaN(cleanMax)) {
        cleanMax = 0;
    }
    btnPlus.disabled = (1 >= cleanMax);

  } else {
    // Variant is sold out
    disableBtns(form);
    btnTxt.innerHTML = `${window.theme.product.soldOut}`;
  }
}